export const DOCUMENT_FILE_EXTENSIONS = ['.pdf', '.doc', '.docx', '.txt', '.md'];

export const DOCUMENT_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
];

const CONVERTED_AT_INGEST_EXTENSION = '.doc';

/**
 * Whether a stored file can be offered as a meeting-note or agenda source. `supportedExtensions`
 * is what the user can upload now (`useSupportedExtensions(DOCUMENT_FILE_EXTENSIONS)`), so a
 * flag-gated format is offered exactly when it could be uploaded. The name decides, because the
 * MIME the browser reported at upload varies (markdown may arrive as text/plain or empty); the
 * MIME list only covers a file whose name has no document extension. A stored .doc is never a
 * source: it is converted to .docx at ingest.
 */
export const isDocumentFile = (
  fileType: string,
  fileName: string,
  supportedExtensions: string[],
): boolean => {
  const dot = fileName.lastIndexOf('.');
  const extension = dot === -1 ? '' : fileName.slice(dot).toLowerCase();
  if (DOCUMENT_FILE_EXTENSIONS.includes(extension)) {
    return extension !== CONVERTED_AT_INGEST_EXTENSION && supportedExtensions.includes(extension);
  }
  return DOCUMENT_MIME_TYPES.includes(fileType);
};
